<template>
  <!-- 标准快递授权 -->
  <div class="expressAuthorization">
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <div v-if="this.globalVariable.tabs.length == 2">
          <el-breadcrumb-item>{{
            this.globalVariable.tabs[0]
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{
            this.globalVariable.tabs[1]
          }}</el-breadcrumb-item>
        </div>
        <div v-else>
          <el-breadcrumb-item>{{
            this.globalVariable.tabs[0]
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{
            this.globalVariable.tabs[1]
          }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{
            this.globalVariable.tabs[2]
          }}</el-breadcrumb-item>
        </div>
      </el-breadcrumb>
    </div>
    <div style="margin-top: 40px">
      <div>
        <h3 style="float: left; line-height: 6px">快递承运商:</h3>
        <el-select
          v-model="carrierId"
          placeholder="请选择"
          style="float: left; width: 80%; margin-left: 25px"
          @change="platformChange()"
        >
          <el-option label="京东宙斯" value="JDWJ" key="1"> </el-option>
          <el-option label="京东物流云" value="JD_WLY" key="1"> </el-option>
          <el-option label="菜鸟" value="TB" key="2"> </el-option>
          <el-option label="唯品会" value="VOP" key="3"> </el-option>
          <el-option label="抖音" value="DY" key="4"> </el-option>
          <el-option label="拼多多" value="PDD" key="5"> </el-option>
          <el-option label="快手" value="KS" key="6"> </el-option>
          <el-option label="得物" value="DW" key="7"> </el-option>
          <el-option label="小红书" value="XHS" key="8"> </el-option>
          <el-option label="LAZADA" value="LAZADA" key="8"> </el-option>
          <el-option label="微信" value="WEIXIN" key="9"> </el-option>
          <el-option label="华为" value="HUAWEI" key="9"> </el-option>
          <el-option label="爱库存" value="AIKUCUN" key="9"> </el-option>
          <el-option label="有赞" value="YOUZAN" key="10"> </el-option>
          <el-option label="速卖通" value="ALIEXPRESS" key="10"> </el-option>
          <el-option label="SHOPEE" value="SHOPEE" key="10"> </el-option>
        </el-select>
      </div>
      <div style="margin-top: 40px">
        <!-- 授权信息 -->
        <h3 style="float: left; line-height: 70px; margin-top: 40px">
          授权&nbsp;&nbsp;&nbsp;&nbsp;信息:
        </h3>
        <table
          v-show="this.carrierId.indexOf('JDWJ') == 0"
          width="80%"
          border="0"
          cellspacing="1"
          cellpadding="4"
          bgcolor="#cccccc"
          class="tabtop13"
          align="center"
        >
          <!-- 京东无界 -->
          <tr>
            <td width="30%" class="btbg font-center titfont">KEY</td>
            <td width="30%" class="btbg font-center titfont">VALUE</td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">app_key</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="app_key" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">app_secret</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="app_secret" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">grant_type</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="grant_type" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">
              code <span style="color: red">*</span>
            </td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="code" />
            </td>
          </tr>
        </table>
        <table
          v-show="this.carrierId.indexOf('JD_WLY') == 0"
          width="80%"
          border="0"
          cellspacing="1"
          cellpadding="4"
          bgcolor="#cccccc"
          class="tabtop13"
          align="center"
        >
          <!-- 京东物流云 -->
          <tr>
            <td width="30%" class="btbg font-center titfont">KEY</td>
            <td width="30%" class="btbg font-center titfont">VALUE</td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">client_id</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="client_id" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">client_secret</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="client_secret" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">
              code <span style="color: red">*</span>
            </td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="code" />
            </td>
          </tr>
        </table>
        <table
          v-show="this.carrierId.indexOf('TB') == 0"
          width="80%"
          border="0"
          cellspacing="1"
          cellpadding="4"
          bgcolor="#cccccc"
          class="tabtop13"
          align="center"
        >
          <!-- 菜鸟 -->
          <tr>
            <td width="30%" class="btbg font-center titfont">KEY</td>
            <td width="30%" class="btbg font-center titfont">VALUE</td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">grant_type</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="grant_type" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">
              code <span style="color: red">*</span>
            </td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="code" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">client_id</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="client_id" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">client_secret</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="client_secret" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">redirect_uri</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="redirect_uri" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">view</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="view" />
            </td>
          </tr>
        </table>
        <table
          v-show="this.carrierId.indexOf('VOP') == 0"
          width="80%"
          border="0"
          cellspacing="1"
          cellpadding="4"
          bgcolor="#cccccc"
          class="tabtop13"
          align="center"
        >
          <!-- 唯品会 -->
          <tr>
            <td width="30%" class="btbg font-center titfont">KEY</td>
            <td width="30%" class="btbg font-center titfont">VALUE</td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">grant_type</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="grant_type" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">
              code <span style="color: red">*</span>
            </td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="code" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">client_id</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="client_id" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">client_secret</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="client_secret" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">redirect_uri</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="redirect_uri" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">request_client_ip</td>
            <td width="10%" class="btbg2 font-center">
              <input
                class="inputclientcustomerid"
                v-model="request_client_ip"
              />
            </td>
          </tr>
        </table>
        <table
          v-show="this.carrierId.indexOf('DY') == 0"
          width="80%"
          border="0"
          cellspacing="1"
          cellpadding="4"
          bgcolor="#cccccc"
          class="tabtop13"
          align="center"
        >
          <tr>
            <td width="10%" class="btbg font-center titfont">KEY</td>
            <td width="10%" class="btbg font-center titfont">VALUE</td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">secret</td>
            <td width="10%" class="btbg2 font-center">
              <input
                type="password"
                class="inputclientcustomerid"
                v-model="secret"
              />
            </td>
          </tr>

          <tr>
            <td width="10%" class="btbg2 font-center">app_key</td>
            <td width="10%" class="btbg2 font-center">
              <input
                type="password"
                class="inputclientcustomerid"
                v-model="app_key"
              />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">method</td>
            <td width="10%" class="btbg2 font-center">
              <input
                type="text"
                class="inputclientcustomerid"
                disabled="disabled"
                v-model="method"
              />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">code <span style="color: red">*</span></td>
            <td width="10%" class="btbg2 font-center">
              <input
                type="text"
                class="inputclientcustomerid"
                v-model="code"
              />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">grant_type <span style="color: red">*</span></td>
            <td width="10%" class="btbg2 font-center">
              <input
                type="text"
                class="inputclientcustomerid"
                v-model="grant_type"
              />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">timestamp</td>
            <td width="10%" class="btbg2 font-center">
              <input
                type="text"
                class="inputclientcustomerid"
                v-model="timestamp"
                disabled="disabled"
              />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">v</td>
            <td width="10%" class="btbg2 font-center">
              <input
                type="text"
                class="inputclientcustomerid"
                v-model="v"
                disabled="disabled"
              />
            </td>
          </tr>
        </table>
        <table
             v-show="this.carrierId.indexOf('PDD') == 0"
          width="80%"
          border="0"
          cellspacing="1"
          cellpadding="4"
          bgcolor="#cccccc"
          class="tabtop13"
          align="center"
            >
              <tr>
                <td width="10%" class="btbg font-center titfont">KEY</td>
                <td width="10%" class="btbg font-center titfont">VALUE</td>
              </tr>
              <tr>
                <td width="10%" class="btbg2 font-center">type</td>
                <td width="10%" class="btbg2 font-center">
                  <input
                    type="text"
                    class="inputclientcustomerid"
                    v-model="type"
                    disabled="disabled"
                  />
                </td>
              </tr>
              <tr>
                <td width="10%" class="btbg2 font-center">secret</td>
                <td width="10%" class="btbg2 font-center">
                  <input
                    type="password"
                    class="inputclientcustomerid"
                    v-model="secret"
                  />
                </td>
              </tr>
              <tr>
                <td width="10%" class="btbg2 font-center">client_id</td>
                <td width="10%" class="btbg2 font-center">
                  <input
                    type="text"
                    class="inputclientcustomerid"
                    v-model="client_id"
                  />
                </td>
              </tr>
              <tr>
                <td width="10%" class="btbg2 font-center">timestamp</td>
                <td width="10%" class="btbg2 font-center">
                  <input
                    type="text"
                    class="inputclientcustomerid"
                    v-model="unixtimestamp"
                    disabled="disabled"
                  />
                </td>
              </tr>
              <tr>
                <td width="10%" class="btbg2 font-center">data_type</td>
                <td width="10%" class="btbg2 font-center">
                  <input
                    type="text"
                    class="inputclientcustomerid"
                    v-model="data_type"
                    disabled="disabled"
                  />
                </td>
              </tr>
              <tr>
                <td width="10%" class="btbg2 font-center">version</td>
                <td width="10%" class="btbg2 font-center">
                  <input
                    type="text"
                    class="inputclientcustomerid"
                    v-model="version"
                    disabled="disabled"
                  />
                </td>
              </tr>
              <tr>
                <!-- 拼多多TOKEN获取 -->
                <td width="10%" class="btbg2 font-center">code  <span style="color: red">*</span></td>
                <td width="10%" class="btbg2 font-center">
                  <input
                    type="text"
                    class="inputclientcustomerid"
                    v-model="code"
                  />
                </td>
              </tr>
            </table>
            <table
          v-show="this.carrierId.indexOf('KS') == 0"
          width="80%"
          border="0"
          cellspacing="1"
          cellpadding="4"
          bgcolor="#cccccc"
          class="tabtop13"
          align="center"
        >
          <!-- 快手授权 -->
          <tr>
            <td width="30%" class="btbg font-center titfont">KEY</td>
            <td width="30%" class="btbg font-center titfont">VALUE</td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">app_id</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="app_id" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">grant_type</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="grant_type" type="text"
                disabled="disabled"/>
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">app_secret</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="app_secret" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">
              code <span style="color: red">*</span>
            </td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="code" />
            </td>
          </tr>
        </table>
        <table
          v-show="this.carrierId.indexOf('DW') == 0"
          width="80%"
          border="0"
          cellspacing="1"
          cellpadding="4"
          bgcolor="#cccccc"
          class="tabtop13"
          align="center"
        >
          <!-- 得物授权 -->
          <tr>
            <td width="30%" class="btbg font-center titfont">KEY</td>
            <td width="30%" class="btbg font-center titfont">VALUE</td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">client_id</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="client_id" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">client_secret</td>
             <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="client_secret" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">
              authorization_code <span style="color: red">*</span>
            </td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="authorization_code" />
            </td>
          </tr>
        </table>
        <table
          v-show="this.carrierId.indexOf('XHS') == 0"
          width="80%"
          border="0"
          cellspacing="1"
          cellpadding="4"
          bgcolor="#cccccc"
          class="tabtop13"
          align="center"
        >
          <!-- 小红书授权 -->
          <tr>
            <td width="30%" class="btbg font-center titfont">KEY</td>
            <td width="30%" class="btbg font-center titfont">VALUE</td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">appId</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="appId" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">code <span style="color: red">*</span></td>
            <td width="10%" class="btbg2 font-center">
              <input
                type="text"
                class="inputclientcustomerid"
                v-model="code"
              />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">version</td>
             <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="version" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">timestamp</td>
            <td width="10%" class="btbg2 font-center">
              <input
                type="text"
                class="inputclientcustomerid"
                v-model="unixtimestamp"
                disabled="disabled"
              />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">method</td>
             <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="method" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">appSecret</td>
             <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="appSecret" />
            </td>
          </tr>
        </table>
        <table
          v-show="this.carrierId.indexOf('LAZADA') == 0"
          width="80%"
          border="0"
          cellspacing="1"
          cellpadding="4"
          bgcolor="#cccccc"
          class="tabtop13"
          align="center"
        >
          <!-- LAZADA授权 -->
          <tr>
            <td width="30%" class="btbg font-center titfont">KEY</td>
            <td width="30%" class="btbg font-center titfont">VALUE</td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">app_key</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="app_key" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">code <span style="color: red">*</span></td>
            <td width="10%" class="btbg2 font-center">
              <input
                type="text"
                class="inputclientcustomerid"
                v-model="code"
              />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">sign_method</td>
             <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="sign_method" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">timestamp</td>
            <td width="10%" class="btbg2 font-center">
              <input
                type="text"
                class="inputclientcustomerid"
                v-model="unixtime"
                disabled="disabled"
              />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">secret</td>
             <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="secret" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">path</td>
             <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="path" />
            </td>
          </tr>
        </table>
        <table
          v-show="this.carrierId.indexOf('WEIXIN') == 0"
          width="80%"
          border="0"
          cellspacing="1"
          cellpadding="4"
          bgcolor="#cccccc"
          class="tabtop13"
          align="center"
        >
          <!-- 微信授权 -->
          <tr>
            <td width="30%" class="btbg font-center titfont">KEY</td>
            <td width="30%" class="btbg font-center titfont">VALUE</td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">appId</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="appId" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">secret</td>
             <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="secret" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">grant_type</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="grant_type" />
            </td>
          </tr>
        </table>
        <table
          v-show="this.carrierId.indexOf('HUAWEI') == 0"
          width="80%"
          border="0"
          cellspacing="1"
          cellpadding="4"
          bgcolor="#cccccc"
          class="tabtop13"
          align="center"
        >
          <!-- 华为授权 -->
          <tr>
            <td width="30%" class="btbg font-center titfont">KEY</td>
            <td width="30%" class="btbg font-center titfont">VALUE</td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">code <span style="color: red">*</span></td>
            <td width="10%" class="btbg2 font-center">
              <input
                type="text"
                class="inputclientcustomerid"
                v-model="code"
              />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">url</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="url" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">ak</td>
             <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="ak" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">sk</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="sk" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">method</td>
            <td width="10%" class="btbg2 font-center">
              <input
                type="text"
                class="inputclientcustomerid"
                v-model="method"
                disabled="disabled"
              />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">timestamp</td>
            <td width="10%" class="btbg2 font-center">
              <input
                type="text"
                class="inputclientcustomerid"
                v-model="unixtime"
                disabled="disabled"
              />
            </td>
          </tr>
        </table>
        <table
          v-show="this.carrierId.indexOf('AIKUCUN') == 0"
          width="80%"
          border="0"
          cellspacing="1"
          cellpadding="4"
          bgcolor="#cccccc"
          class="tabtop13"
          align="center"
        >
          <!-- 微信授权 -->
          <tr>
            <td width="30%" class="btbg font-center titfont">KEY</td>
            <td width="30%" class="btbg font-center titfont">VALUE</td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">code <span style="color: red">*</span></td>
            <td width="10%" class="btbg2 font-center">
              <input
                type="text"
                class="inputclientcustomerid"
                v-model="code"
              />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">appId</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="appId" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">appSecret</td>
             <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="appSecret" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">format</td>
            <td width="10%" class="btbg2 font-center">
              <input
                type="text"
                class="inputclientcustomerid"
                v-model="format"
                disabled="disabled"
              />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">interfaceName</td>
            <td width="10%" class="btbg2 font-center">
              <input
                type="text"
                class="inputclientcustomerid"
                v-model="interfaceName"
                disabled="disabled"
              />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">version</td>
            <td width="10%" class="btbg2 font-center">
              <input
                type="text"
                class="inputclientcustomerid"
                v-model="version"
                disabled="disabled"
              />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">timestamp</td>
            <td width="10%" class="btbg2 font-center">
              <input
                type="text"
                class="inputclientcustomerid"
                v-model="unixtimestamp"
                disabled="disabled"
              />
            </td>
          </tr>
        </table>
        <table
            v-show="this.carrierId.indexOf('YOUZAN') == 0"
            width="80%"
            border="0"
            cellspacing="1"
            cellpadding="4"
            bgcolor="#cccccc"
            class="tabtop13"
            align="center"
        >
          <!-- 有赞授权 -->
          <tr>
            <td width="30%" class="btbg font-center titfont">KEY</td>
            <td width="30%" class="btbg font-center titfont">VALUE</td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">client_id</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="client_id" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">client_secret</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="client_secret" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">authorize_type</td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="authorize_type" />
            </td>
          </tr>
          <tr>
            <td width="10%" class="btbg2 font-center">code    <span style="color:red;">*</span></td>
            <td width="10%" class="btbg2 font-center">
              <input class="inputclientcustomerid" v-model="code" />
            </td>
          </tr>
        </table>
        <table
                  v-show="this.carrierId.indexOf('ALIEXPRESS') == 0"
                  width="80%"
                  border="0"
                  cellspacing="1"
                  cellpadding="4"
                  bgcolor="#cccccc"
                  class="tabtop13"
                  align="center"
          >
              <!-- 速卖通 授权 -->
             <!-- API: https://open.aliexpress.com/doc/api.htm?spm=a2o9m.11193531.0.0.11493b53TIKEDh#/api?cid=3&path=/auth/token/create&methodType=GET/POST -->
              <tr>
                  <td width="30%" class="btbg font-center titfont">KEY</td>
                  <td width="30%" class="btbg font-center titfont">VALUE</td>
              </tr>
              <tr>
                  <td width="10%" class="btbg2 font-center">AppKey</td>
                  <td width="10%" class="btbg2 font-center">
                      <input class="inputclientcustomerid" v-model="AppKey" />
                  </td>
              </tr>
              <tr>
                  <td width="10%" class="btbg2 font-center">AppSecret</td>
                  <td width="10%" class="btbg2 font-center">
                      <input class="inputclientcustomerid" v-model="AppSecret" />
                  </td>
              </tr>
              <tr>
                  <td width="10%" class="btbg2 font-center">code<span style="color:red;">*</span></td>
                  <td width="10%" class="btbg2 font-center">
                      <input class="inputclientcustomerid" v-model="code" />
                  </td>
              </tr>
              <tr>
                <td width="10%" class="btbg2 font-center">timestamp</td>
                <td width="10%" class="btbg2 font-center">
                    <input
                            type="text"
                            class="inputclientcustomerid"
                            v-model="unixtime"
                            disabled="disabled"
                    />
                </td>
              </tr>
              <tr>
                  <td width="10%" class="btbg2 font-center">sign_method</td>
                  <td width="10%" class="btbg2 font-center">
                      <input class="inputclientcustomerid" v-model="sign_method" disabled="disabled" />
                  </td>
              </tr>
              <tr>
                  <td width="10%" class="btbg2 font-center">simplify</td>
                  <td width="10%" class="btbg2 font-center">
                      <input class="inputclientcustomerid" v-model="simplify" disabled="disabled" />
                  </td>
              </tr>
              <tr>
                  <td width="10%" class="btbg2 font-center">method</td>
                  <td width="10%" class="btbg2 font-center">
                      <input class="inputclientcustomerid" v-model="method" disabled="disabled" />
                  </td>
              </tr>
          </table>
        <table
                  v-show="this.carrierId.indexOf('SHOPEE') == 0"
                  width="80%"
                  border="0"
                  cellspacing="1"
                  cellpadding="4"
                  bgcolor="#cccccc"
                  class="tabtop13"
                  align="center"
          >
              <!-- SHOPEE授权 -->
              <tr>
                  <td width="30%" class="btbg font-center titfont">KEY</td>
                  <td width="30%" class="btbg font-center titfont">VALUE</td>
              </tr>
              <tr>
                  <td width="10%" class="btbg2 font-center">partner_id<span style="color:red;">*</span></td>
                  <td width="10%" class="btbg2 font-center">
                      <input class="inputclientcustomerid" v-model="partner_id" />
                  </td>
              </tr>
              <tr>
                  <td width="10%" class="btbg2 font-center">secretKey<span style="color:red;">*</span></td>
                  <td width="10%" class="btbg2 font-center">
                      <input class="inputclientcustomerid" v-model="secretKey" />
                  </td>
              </tr>
              <tr>
                  <td width="10%" class="btbg2 font-center">code<span style="color:red;">*</span></td>
                  <td width="10%" class="btbg2 font-center">
                      <input class="inputclientcustomerid" v-model="code" />
                  </td>
              </tr>
              <tr>
                  <td width="10%" class="btbg2 font-center">shop_id</td>
                  <td width="10%" class="btbg2 font-center">
                      <input class="inputclientcustomerid" v-model="shop_id" />
                  </td>
              </tr>
              <tr>
                  <td width="10%" class="btbg2 font-center">main_account_id</td>
                  <td width="10%" class="btbg2 font-center">
                      <input class="inputclientcustomerid" v-model="main_account_id" />
                  </td>
              </tr>
              <tr>
                  <td width="10%" class="btbg2 font-center">timestamp</td>
                  <td width="10%" class="btbg2 font-center">
                      <input
                              type="text"
                              class="inputclientcustomerid"
                              v-model="unixtimestamp"
                              disabled="disabled"
                      />
                  </td>
              </tr>
            <tr>
                <td width="10%" class="btbg2 font-center">path</td>
                <td width="10%" class="btbg2 font-center">
                    <input class="inputclientcustomerid" v-model="path" disabled="disabled" />
                </td>
            </tr>
          </table>
      </div>
    </div>
    <div style="margin-top: 40px">
      <!-- 结果 -->
      <h3 style="float: left; line-height: 30px; margin-top: 40px">
        授权&nbsp;&nbsp;&nbsp;&nbsp;结果:
      </h3>
      <el-input
        type="textarea"
        style="float: left; width: 80%; margin-left: 25px; margin-top: 40px"
        :rows="4"
        width="80%"
        placeholder="响应内容"
        v-model="response"
        disabled
      >
      </el-input>
    </div>
    <div style="margin-top: 40px">
      <el-button
        type="success"
        plain
        style="float: left; height: 40px; margin-top: 40px; width: 100px"
        @click="expressAuthorization()"
        >生成</el-button
      >
      <el-input
        v-model="sendUrl"
        style="
          margin-left: 15px;
          float: left;
          width: 80%;
          height: 40px;
          margin-top: 40px;
        "
      ></el-input>
    </div>
  </div>
</template>

<script>
// 快递授权调用api
import { expressAuthorization } from "@/api/api";
export default {
  data() {
    return {
      //承运商
      carrierId: "JDWJ",
      //发送地址
      sendUrl: "https://open-oauth.jd.com/oauth2/access_token",
      //时间
      timestamp: "",
      //linux时间戳
      unixtimestamp: "",
      //京东无界
      app_key: "",
      app_secret: "",
      grant_type: "authorization_code",
      code: "",
      //菜鸟
      client_id: "",
      client_secret: "",
      redirect_uri: "",
      view: "",
      //唯品会
      request_client_ip: "",
      //抖音
      secret: "",
      method: "",
      v: "",
      //拼多多
      type:"",
      data_type:"",
      version:"",
      //快手
      app_id:"",
      //得物
      authorization_code:"",
      //小红书
      appId:"",
      appSecret:"",
      //LAZADA
      sign_method:"",
      path:"",
      //华为
      ak:"",
      sk:"",
      url:"",
      //爱库存
      interfaceName:"",
      //有赞
      authorize_type:"",
      //速卖通
      AppKey:"",
      AppSecret:"",
      simplify:"",
      unixtime:"",
      //SHOPEE
      partner_id:"",
      secretKey:"",
      shop_id:"",
      main_account_id:"",
      //结果
      response: "",
    };
  },
  created() {
    this.globalVariable.setTabs(["快递业务", "快递授权"]);
    var vm = this;
    vm.timer = setInterval(() => {
      var y = new Date().getFullYear();
      var m = new Date().getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = new Date().getDate();
      d = d < 10 ? "0" + d : d;
      var ho = new Date().getHours();
      ho = ho < 10 ? "0" + ho : ho;
      var mi =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      var ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      //修改数据date
      vm.timestamp = y + "-" + m + "-" + d + " " + ho + ":" + mi + ":" + ss;
      vm.unixtime = new Date().getTime() + "";
      //unix时间戳
      vm.unixtimestamp = vm.unixtime.slice(0, 10);
    }, 1000);
  },
  methods: {
    platformChange() {
      if (this.carrierId == "JDWJ") {
        this.app_key = "";
        this.app_secret = "";
        this.grant_type = "authorization_code";
        this.code = "";
        this.sendUrl = "https://open-oauth.jd.com/oauth2/access_token";
        this.response = "";
      } else if (this.carrierId == "TB") {
        this.grant_type = "authorization_code";
        this.code = "";
        this.client_id = "";
        this.client_secret = "";
        //20230309 shangjian 修改菜鸟获取授权的回调地址
        //20250904 yuyuxiao 修改菜鸟获取授权的回调地址，原:https://www.flux.com.cn/
        this.redirect_uri = "https://test5mysql.wmsdev.net:18080/y10PrtBizSrv/oauth/callBack";
        this.view = "web";
        this.sendUrl = "https://oauth.taobao.com/token";
        this.response = "";
      } else if (this.carrierId == "VOP") {
        this.client_id = "";
        this.client_secret = "";
        this.grant_type = "authorization_code";
        //20250904 yuyuxiao 修改唯品会获取授权的回调地址，原:http://openapi.flux.com.cn/openPlateform
        this.redirect_uri = "https://test5mysql.wmsdev.net:18080/y10PrtBizSrv/oauth/callBack";
        this.request_client_ip = "101.132.122.238";
        this.code = "";
        this.sendUrl = "https://auth.vip.com/oauth2/token";
        this.response = "";
      } else if (this.carrierId == "DY") {
        this.secret = "";
        this.app_key = "";
        this.method = "token.create";
        this.code = "";
        this.grant_type = "authorization_code"
        this.v = "2";
        this.sendUrl = "https://openapi-fxg.jinritemai.com/token/create";
        this.response = "";
      } else if (this.carrierId == "PDD") {
        //拼多多发货地址
        this.secret = "";
        this.type = "pdd.pop.auth.token.create";
        this.client_id = "";
        this.data_type = "JSON";
        this.version = "V1";
        this.code = "";
        this.sendUrl = "https://gw-api.pinduoduo.com/api/router";
        this.response = "";
      } else if (this.carrierId == "KS") {
        //快手授权
        this.app_id = "";
        this.grant_type = "code";
        this.code = "";
        this.app_secret = "";
        this.sendUrl = "https://openapi.kwaixiaodian.com/oauth2/access_token";
        this.response = "";
      } else if (this.carrierId == "DW") {
        //得物授权
        this.client_id = "";
        this.client_secret = "";
        this.authorization_code = "";
        this.sendUrl = "https://open.dewu.com/api/v1/h5/passport/v1/oauth2/token";
        this.response = "";
      } else if (this.carrierId == "XHS") {
        //小红书授权
        this.appId = "";
        this.appSecret = "";
        this.version = "2.0";
        this.timestamp = "";
        this.method = "oauth.getAccessToken";
        this.code = "";
        this.sendUrl = "https://ark.xiaohongshu.com/ark/open_api/v3/common_controller";
        this.response = "";
      } else if (this.carrierId == "LAZADA") {
        //LAZADA授权
        this.app_key = "";
        this.secret = "";
        this.timestamp = "";
        this.sign_method = "sha256";
        this.path = "/auth/token/create";
        this.code = "";
        this.sendUrl = "https://auth.lazada.com/rest/auth/token/create";
        this.response = "";
      } else if (this.carrierId == "WEIXIN") {
        //微信授权
        this.appId = "";
        this.secret = "";
        this.grant_type = "client_credential";
        this.sendUrl = "https://api.weixin.qq.com/cgi-bin/stable_token";
        this.response = "";
      } else if (this.carrierId == "HUAWEI") {
        //华为授权
        this.ak = "";
        this.sk = "";
        this.timestamp = "";
        this.method = "POST";
        this.url = "/bop/server/openerp/getAuthToken";
        this.code = "";
        this.sendUrl = "https://openapi.vmall.com/bop/server/openerp/getAuthToken";
        this.response = "";
      } 
      else if (this.carrierId == "AIKUCUN") {
        //爱库存授权
        this.appId = "";
        this.appSecret = "";
        this.timestamp = "";
        this.version = "1.0";
        this.format = "json";
        this.interfaceName = "aikucun.auth.token.create";
        this.code = "";
        this.sendUrl = "https://openapi.aikucun.com/route/rest";
        this.response = "";
      } 
      else if (this.carrierId == "JD_WLY") {
        this.client_id = "";
        this.client_secret = "";
        this.code = "";
        this.sendUrl = "https://oauth.jdl.com/oauth/token";
        this.response = "";
      }else if (this.carrierId == "YOUZAN") {
        //有赞
        this.client_id = "";
        this.client_secret = "";
        this.authorize_type = "authorization_code";
        this.sendUrl = "https://open.youzanyun.com/auth/token";
        this.response = "";
      }
      else if (this.carrierId == "ALIEXPRESS") {
          // 速卖通
          this.AppKey = "";
          this.AppSecret = "";
          this.code = "";
          this.timestamp = "";
          this.sign_method = "sha256";
          this.simplify = "true";
          this.method = "/auth/token/create";
          this.sendUrl = "http://api-sg.aliexpress.com/rest/auth/token/create";
          this.response = "";
      }else if (this.carrierId == "SHOPEE") {
          // SHOPEE
          this.partner_id = "";
          this.secretKey = "";
          this.code = "";
          this.shop_id = "";
          this.main_account_id = "";
          this.timestamp = "";
          this.path = "/api/v2/auth/token/get";
          this.sendUrl = "https://openplatform.shopee.cn/api/v2/auth/token/get";
          this.response = "";
      }
    },
    expressAuthorization() {
      if (this.carrierId == "JDWJ") {
        expressAuthorization(
          {
            carrierId: this.carrierId,
            sendUrl: this.sendUrl,
            app_key: this.app_key,
            app_secret: this.app_secret,
            grant_type: this.grant_type,
            code: this.code,
          },
          ""
        ).then((res) => {
          try {
            this.response = JSON.stringify(res);
          } catch (error) {
            this.response = res;
          }
        });
      } else if (this.carrierId == "TB") {
        expressAuthorization(
          {
            carrierId: this.carrierId,
            sendUrl: this.sendUrl,
            grant_type: this.grant_type,
            code: this.code,
            client_id: this.client_id,
            client_secret: this.client_secret,
            redirect_uri: this.redirect_uri,
            view: this.view,
          },
          ""
        ).then((res) => {
          try {
            this.response = JSON.stringify(res);
          } catch (error) {
            this.response = res;
          }
        });
      } else if (this.carrierId == "VOP") {
        expressAuthorization(
          {
            carrierId: this.carrierId,
            sendUrl: this.sendUrl,
            client_id: this.client_id,
            client_secret: this.client_secret,
            grant_type: this.grant_type,
            redirect_uri: this.redirect_uri,
            request_client_ip: this.request_client_ip,
            code: this.code,
          },
          ""
        ).then((res) => {
          try {
            this.response = JSON.stringify(res);
          } catch (error) {
            this.response = res;
          }
        });
      } else if (this.carrierId == "DY") {
        expressAuthorization(
          {
            carrierId: this.carrierId,
            sendUrl: this.sendUrl,
            secret: this.secret,
            app_key: this.app_key,
            method: this.method,
            param_json: '{"code":"'+this.code+'",'+'"grant_type":"'+this.grant_type+'"}',
            timestamp: this.timestamp,
            v: this.v,
          },
          ""
        ).then((res) => {
          try {
            this.response = JSON.stringify(res);
          } catch (error) {
            this.response = res;
          }
        });
      } else if (this.carrierId == "PDD") {
        expressAuthorization(
          {
            carrierId: this.carrierId,
            sendUrl: this.sendUrl,
            secret: this.secret,
            type: this.type,
            client_id: this.client_id,
            timestamp: this.unixtimestamp,
            data_type: this.data_type,
            version: this.version,
            code: this.code,
          },
          ""
        ).then((res) => {
          try {
            this.response = JSON.stringify(res);
          } catch (error) {
            this.response = res;
          }
        });
      } else if (this.carrierId == "KS") {
        expressAuthorization(
          {
            carrierId: this.carrierId,
            sendUrl: this.sendUrl,
            app_id: this.app_id,
            grant_type: this.grant_type,
            code: this.code,
            app_secret: this.app_secret
          },
          ""
        ).then((res) => {
          try {
            this.response = JSON.stringify(res);
          } catch (error) {
            this.response = res;
          }
        });
      } else if (this.carrierId == "DW") {
        expressAuthorization(
          {
            carrierId: this.carrierId,
            sendUrl: this.sendUrl,
            client_id: this.client_id,
            client_secret: this.client_secret,
            authorization_code: this.authorization_code
          },
          ""
        ).then((res) => {
          try {
            this.response = JSON.stringify(res);
          } catch (error) {
            this.response = res;
          }
        });
      } else if (this.carrierId == "XHS") {
        expressAuthorization(
          {
            carrierId: this.carrierId,
            sendUrl: this.sendUrl,
            appId: this.appId,
            version: this.version,
            appSecret: this.appSecret,
            timestamp: this.unixtimestamp,
            method: this.method,
            code: this.code,
          },
          ""
        ).then((res) => {
          try {
            this.response = JSON.stringify(res);
          } catch (error) {
            this.response = res;
          }
        });
      } else if (this.carrierId == "LAZADA") {
        expressAuthorization(
          {
            carrierId: this.carrierId,
            sendUrl: this.sendUrl,
            app_key: this.app_key,
            sign_method: this.sign_method,
            secret: this.secret,
            timestamp: this.unixtime,
            path: this.path,
            code: this.code,
          },
          ""
        ).then((res) => {
          try {
            this.response = JSON.stringify(res);
          } catch (error) {
            this.response = res;
          }
        });
      } else if (this.carrierId == "WEIXIN") {
        expressAuthorization(
          {
            carrierId: this.carrierId,
            sendUrl: this.sendUrl,
            appId: this.appId,
            secret: this.secret,
            grant_type: this.grant_type,
          },
          ""
        ).then((res) => {
          try {
            this.response = JSON.stringify(res);
          } catch (error) {
            this.response = res;
          }
        });
      } else if (this.carrierId == "HUAWEI") {
        expressAuthorization(
          {
            carrierId: this.carrierId,
            sendUrl: this.sendUrl,
            sk: this.sk,
            ak: this.ak,
            url: this.url,
            timestamp: this.unixtime,
            method: this.method,
            code: this.code,
          },
          ""
        ).then((res) => {
          try {
            this.response = JSON.stringify(res);
          } catch (error) {
            this.response = res;
          }
        });
      } else if (this.carrierId == "AIKUCUN") {
        expressAuthorization(
          {
            carrierId: this.carrierId,
            sendUrl: this.sendUrl,
            appId: this.appId,
            appSecret: this.appSecret,
            format: this.format,
            timestamp: this.unixtimestamp,
            interfaceName: this.interfaceName,
            version: this.version,
            code: this.code,
          },
          ""
        ).then((res) => {
          try {
            this.response = JSON.stringify(res);
          } catch (error) {
            this.response = res;
          }
        });
      } else if (this.carrierId == "JD_WLY") {
        expressAuthorization(
          {
            carrierId: this.carrierId,
            sendUrl: this.sendUrl,
            client_id: this.client_id,
            client_secret: this.client_secret,
            code: this.code,
          },
          ""
        ).then((res) => {
          try {
            this.response = JSON.stringify(res);
          } catch (error) {
            this.response = res;
          }
        });
      }
      else if (this.carrierId == "YOUZAN") {
        expressAuthorization(
            {
              carrierId: this.carrierId,
              client_secret: this.client_secret,
              sendUrl: this.sendUrl,
              client_id: this.client_id,
              code: this.code,
              authorize_type: this.authorize_type
            },
            ""
        ).then((res) => {
          try {
            this.response = JSON.stringify(res);
          } catch (error) {
            this.response = res;
          }
        });
      }
      else if (this.carrierId == "ALIEXPRESS") {
          expressAuthorization(
              {
                  carrierId: this.carrierId,
                  AppKey: this.AppKey,
                  AppSecret: this.AppSecret,
                  code: this.code,
                  timestamp: this.unixtime,
                  sign_method: this.sign_method,
                  simplify: this.simplify,
                  method: this.method,
                  sendUrl: this.sendUrl,
              },
              ""
          ).then((res) => {
              try {
                  this.response = JSON.stringify(res);
              } catch (error) {
                  this.response = res;
              }
          });
      }
      else if (this.carrierId == "SHOPEE") {
          expressAuthorization(
              {
                  carrierId: this.carrierId,
                  partner_id : this.partner_id,
                  secretKey : this.secretKey,
                  code : this.code,
                  shop_id : this.shop_id,
                  main_account_id : this.main_account_id,
                  timestamp : this.unixtimestamp,
                  path : this.path,
                  sendUrl : this.sendUrl,
                  response : this.response,
              },
              ""
          ).then((res) => {
              try {
                  this.response = JSON.stringify(res);
              } catch (error) {
                  this.response = res;
              }
          });
      }
    },
  },
};
</script>

<style scoped>
.el-select {
  display: inline-block;
  position: relative;
  width: 80%;
}
.inputclientcustomerid {
  border: none;
  width: 200px;
}
.inputclientcustomerid:focus {
  outline: none;
  border: 1px solid gray;
}
.tabtop13 {
  float: left;
  width: 80%;
  margin-left: 25px;
  margin-top: 40px;
}
.tabtop13 td {
  background-color: #ffffff;
  height: 25px;
  line-height: 150%;
}
.font-center {
  text-align: center;
}
.btbg {
  background: #e9faff !important;
}
.btbg1 {
  background: #f2fbfe !important;
}
.btbg2 {
  background: #f3f3f3 !important;
}
.biaoti {
  font-family: 微软雅黑;
  font-size: 26px;
  font-weight: bold;
  border-bottom: 1px dashed #cccccc;
  color: #255e95;
}
.titfont {
  font-family: 微软雅黑;
  font-size: 16px;
  font-weight: bold;
  color: #255e95;
  background-color: #e9faff;
}
.tabtxt2 {
  font-family: 微软雅黑;
  font-size: 14px;
  font-weight: bold;
  text-align: right;
  padding-right: 10px;
  color: #327cd1;
}
.tabtxt3 {
  font-family: 微软雅黑;
  font-size: 14px;
  padding-left: 15px;
  color: #000;
  margin-top: 10px;
  margin-bottom: 10px;
  line-height: 20px;
}
</style>